'use client';

import classNames from 'classnames';

import Moon from '@/icons/react/Moon';
import Sun from '@/icons/react/Sun';
import { type ThemeModeType, useTheme } from '@/providers';

function ThemeButton({ modeName }: { modeName: ThemeModeType }) {
  const { themeMode, setThemeMode } = useTheme();
  const id = `theme-button-${modeName}`;
  const iconClasses = 'block w-5 md:w-4 h-5 md:h-4';
  const isActive = themeMode === modeName;

  return (
    <>
      <input
        id={id}
        type="checkbox"
        value={modeName}
        name={modeName}
        onChange={(event) => setThemeMode(event.target.value as ThemeModeType)}
        checked={isActive}
        className="sr-only"
      />
      <label
        htmlFor={id}
        className={classNames(
          'w-9 h-9 flex items-center justify-center rounded-full cursor-pointer',
          'md:w-6 md:h-6',
          {
            'bg-gray-300 dark:bg-gray-600': isActive,
          },
        )}
      >
        <span className="sr-only">{modeName}</span>

        {modeName === 'light' && <Sun className={iconClasses} />}
        {modeName === 'dark' && <Moon className={iconClasses} />}
        {/* {name === 'system' && <Desktop className={iconClasses} />} */}
      </label>
    </>
  );
}

export function ThemeToggle() {
  return (
    <div
      className={classNames(
        'flex items-center gap-half border rounded-full p-half',
        'shrink-0 grow-0',
        'border-primary dark:border-gray-600',
      )}
    >
      <ThemeButton modeName="light" />
      <ThemeButton modeName="dark" />
      {/* <ThemeButton name="system" /> */}
    </div>
  );
}
